<script>
  import { token } from "./store/token.js";
  import { section } from "./store/section.js";
  import { user } from "./store/user.js";
  import { client_login } from "./store/client_login.js";

  import NewLogin from "./layout/Login.svelte";
  import NewSignup from "./layout/Signup.svelte";
  import NewForgotPassword from "./layout/ForgotPassword.svelte";
  import NewResetPassword from "./layout/ResetPassword.svelte";
  import NewVerifyEmail from "./layout/VerifyEmail.svelte";

  import TokenLogin from "./layout/TokenLogin.svelte";

  import AppAccount from "./AppAccount.svelte";

  import {
    fetch_workspace_list,
    handle_token_exchange,
    fetch_workspace_billing_info,
  } from "./api/request.js";

  import { active_workspace } from "./store/workspace.js";
  import { workspace_list } from "./store/workspace_list.js";
  import { active_subscription } from "./store/subscription.js";

  $: is_logged = $token != "";

  const url_search_params = new URLSearchParams(window.location.search);
  const url_params = Object.fromEntries(url_search_params.entries());

  console.log(url_params);

  if (url_params.action == "create_and_subscribe") {
    section.set("account/workspaces/create_subscribe");
  }

  if (url_params.action == "reset_password") {
    token.set("");
    section.set("public/reset_password");
  }

  if (url_params.action == "verify_email") {
    token.set("");
    section.set("public/verify_email");
  }

  if (url_params.action == "forgot_password") {
    token.set("");
    section.set("public/forgot_password");
  }

  const setup_upgrade_state = async () => {
    const token_exchange_result = await handle_token_exchange(
      url_params.access_token,
    );

    client_login.set(true);

    token.set(token_exchange_result.token);
    user.set(token_exchange_result.user);

    const local_workspace_list = await fetch_workspace_list($token);

    workspace_list.set(local_workspace_list);

    const selected_workspace = $workspace_list
      .filter((workspace) => {
        if (workspace.string_id == url_params.workspace_id) {
          return workspace;
        }
      })
      .pop();

    active_workspace.set(selected_workspace);

    const subscription_data = await fetch_workspace_billing_info(
      $active_workspace.string_id,
      $token,
    );

    active_subscription.set(subscription_data);

    section.set("account/workspaces/overview/change_plan");
  };

  const setup_manage_workspace_state = async () => {
    const token_exchange_result = await handle_token_exchange(
      url_params.access_token,
    );

    client_login.set(true);

    section.set("account/workspaces/overview");

    token.set(token_exchange_result.token);
    user.set(token_exchange_result.user);

    //const local_workspace_list = await fetch_workspace_list($token);
    const local_workspace_list = await fetch_workspace_list($token);

    workspace_list.set(local_workspace_list);

    const selected_workspace = $workspace_list
      .filter((workspace) => {
        if (workspace.string_id == url_params.workspace_id) {
          return workspace;
        }
      })
      .pop();

    active_workspace.set(selected_workspace);

    const subscription_data = await fetch_workspace_billing_info(
      $active_workspace.string_id,
      $token,
    );

    active_subscription.set(subscription_data);
  };

  if (url_params.action == "manage_plan") {
    setup_upgrade_state();
  }

  if (url_params.action == "manage_workspace") {
    setup_manage_workspace_state();
  }

  console.log($section);

  const check_error = (error) => {
    if (error.message == "unauthorized") {
      token.set("");
      workspace_list.set([]);
      user.set({});
    }
  };
</script>

{#if false}
  x
{:else if is_logged}
  <AppAccount check_error={check_error} />
{:else if !is_logged && url_params.access_token}
  <TokenLogin />
{:else if !is_logged && $section == "public/login"}
  <NewLogin />
{:else if !is_logged && $section == "public/signup"}
  <NewSignup />
{:else if !is_logged && $section == "public/forgot_password"}
  <NewForgotPassword />
{:else if !is_logged && $section == "public/reset_password"}
  <NewResetPassword />
{:else if !is_logged && $section == "public/verify_email"}
  <NewVerifyEmail />
{:else}
  <NewLogin />
{/if}
